import getSelectValue from 'utils/getSelectValue';
import { $form as formSignal } from 'signals/global.signals';

export function getPortfolioFormData(data) {
  return {
    companyName: data.companyName,
    teamId: getSelectValue(data.teamId),
    investmentStage: getSelectValue(data.investmentStage),
    lastRoundSize: data.lastRoundSize,
    raisedToDate: data.raisedToDate,
    holdingsPct: data.holdingsPct,
    holdingsValue: data.holdingsValue,
    currentValuation: data.currentValuation,
    arr: data.arr,
    mrr: data.mrr,
  };
}

export const getPortfolioInvestmentEntryInputValue = ({ $form = formSignal, id, name }) => $form.value.portfolioInvestmentEntries[id][name];

export const getPortfolioHoldingEntryInputValue = ({ $form = formSignal, id, name }) => $form.value.portfolioHoldingEntries[id][name];
